import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { PartTypeCategoriesKey, PartTypeCategory } from '../@types/partTypeCategory.type';
import { getPartTypeCategories } from '../api/partTypeCategories';


export const useGetPartTypeCategories = (): UseQueryResult<PartTypeCategory[]> => {
  return useQuery({
    queryKey: [PartTypeCategoriesKey],
    queryFn: () => getPartTypeCategories(),
    staleTime: 2 * 60 * 60 * 1000
  });
};